/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserSigninInitRequest = {
  properties: {
    type: {
      type: 'SigninType',
      isRequired: true,
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
  },
} as const;
